import type { ReactElement } from 'react';
import { HeapEvent } from 'config';
import { Component as MinusIcon } from 'icons/icon-ui--minus.svg';
import { Component as PlusIcon } from 'icons/icon-ui--plus.svg';

type Props = {
  id: string;
  ariaLabel: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  onMinusPointerEnter?: () => void;
  onMinusPointerLeave?: () => void;
  onMinusTouch?: () => void;
  onPlusPointerEnter?: () => void;
  onPlusPointerLeave?: () => void;
  onPlusTouch?: () => void;
  heapEventTicker?: HeapEvent;
  isDisabled?: boolean;
};

function NumberPicker({
  id,
  ariaLabel,
  value,
  min,
  max,
  step = 1,
  onChange,
  onMinusPointerEnter = () => null,
  onMinusPointerLeave = () => null,
  onMinusTouch = () => null,
  onPlusPointerEnter = () => null,
  onPlusPointerLeave = () => null,
  onPlusTouch = () => null,
  heapEventTicker,
  isDisabled = false,
}: Props): ReactElement {
  return (
    <div className="c-input-number-picker" aria-label={ariaLabel}>
      <button
        id={`${id}-decrease`}
        className={[
          'c-input-number-picker__decrease',
          heapEventTicker,
        ].join(' ')}
        aria-label="Decrease"
        type="button"
          // @ts-expect-error TODO: fix null safety
        disabled={isDisabled || value <= min}
        onClick={() => onChange(value - step)}
        onTouchEnd={onMinusTouch}
        onPointerEnter={onMinusPointerEnter}
        onPointerLeave={onMinusPointerLeave}
      >
        <MinusIcon />
      </button>

      <input
        id={id}
        type="number"
        value={value}
        step={step}
        min={min}
        max={max}
        tabIndex={-1}
        readOnly
      />

      <button
        id={`${id}-decrease`}
        className={[
          'c-input-number-picker__increase',
          heapEventTicker,
        ].join(' ')}
        aria-label="Increase"
        type="button"
          // @ts-expect-error TODO: fix null safety
        disabled={isDisabled || value >= max}
        onClick={() => onChange(value + step)}
        onTouchEnd={onPlusTouch}
        onPointerEnter={onPlusPointerEnter}
        onPointerLeave={onPlusPointerLeave}
      >
        <PlusIcon />
      </button>
    </div>
  );
}

export default NumberPicker;
